import { SxStyleProp } from 'theme-ui';

export const baseStyle: { [k: string]: SxStyleProp } = {
  mainContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    marginBottom: '-43px',

    '@media (min-width: 1024px)': {
      marginBottom: '-84px',
    },

    '& > a': {
      position: 'relative',

      '&::after': {
        content: '""',
        display: 'block',
        height: '100%',
        left: '50%',
        position: 'absolute',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
      },
    },

    '& > *': {
      marginBottom: '43px',
      width: '100%',

      '@media (min-width: 1024px)': {
        marginBottom: '84px',
        marginRight: '44px',
        width: 'calc(33% - (88px/3))',

        '&:nth-of-type(3n)': {
          marginRight: 0,
        },
      },
      '@media (min-width: 1600px)': {
        marginRight: '77px',
        width: 'calc(33% - (140px/3))',
      },
    },
  },
};
